import { RootSearchStateSchema } from "../types/rootSearchTypes";

export const getRootSearchState = (state: RootSearchStateSchema) => state.rootSearch; 